import { BookNowStatuses } from 'Douleutaras/types';

export const quoteAcceptedBidBookNowStatuses = [
  BookNowStatuses.QUOTE_ACCEPTED,
  BookNowStatuses.JOB_WILL_NOT_START,
  BookNowStatuses.JOB_STARTED,
  BookNowStatuses.CANNOT_BE_COMPLETED,
  BookNowStatuses.COMPLETION_PENDING,
  BookNowStatuses.COMPLETED
];

// The positive statuses are sorted by least to most latest ones (towards job completion)
export const PositiveBookNowStatuses = [
  BookNowStatuses.ACTIVE,
  BookNowStatuses.MEETING_SCHEDULED,
  BookNowStatuses.MEETING_DONE,
  BookNowStatuses.TO_FOLLOW_UP,
  BookNowStatuses.QUOTE_CUSTOMER_THINKING,
  BookNowStatuses.QUOTE_SENT,
  BookNowStatuses.QUOTE_ACCEPTED,
  BookNowStatuses.JOB_STARTED,
  BookNowStatuses.COMPLETION_PENDING,
  BookNowStatuses.COMPLETED
];

export const NegativeBookNowStatuses = [
  BookNowStatuses.CANNOT_BE_COMPLETED,
  BookNowStatuses.MEETING_NOT_SCHEDULED,
  BookNowStatuses.MEETING_NOT_DONE,
  BookNowStatuses.QUOTE_NOT_SENT,
  BookNowStatuses.QUOTE_NOT_ACCEPTED,
  BookNowStatuses.JOB_WILL_NOT_START
];

// These statuses are set when pro has denied a bid
export const ProDenialBookNowStatuses = [
  BookNowStatuses.MEETING_NOT_SCHEDULED,
  BookNowStatuses.QUOTE_NOT_SENT,
  BookNowStatuses.QUOTE_NOT_ACCEPTED,
  BookNowStatuses.CANNOT_BE_COMPLETED,
  BookNowStatuses.JOB_WILL_NOT_START,
  BookNowStatuses.MEETING_NOT_DONE
];

// Warning !!! position matters, do not change if you don't know what you're doing
export const AllBookNowStatuses = [
  BookNowStatuses.JOB_POST,
  BookNowStatuses.ACTIVE,

  BookNowStatuses.MEETING_NOT_SCHEDULED,
  BookNowStatuses.MEETING_SCHEDULED,
  BookNowStatuses.MEETING_DONE,

  BookNowStatuses.TO_FOLLOW_UP,
  BookNowStatuses.MEETING_NOT_DONE,

  BookNowStatuses.QUOTE_NOT_SENT,
  BookNowStatuses.QUOTE_NOT_ACCEPTED,
  BookNowStatuses.QUOTE_CUSTOMER_THINKING,
  BookNowStatuses.QUOTE_SENT,
  BookNowStatuses.QUOTE_ACCEPTED,

  BookNowStatuses.JOB_STARTED,
  BookNowStatuses.JOB_WILL_NOT_START,
  BookNowStatuses.CANNOT_BE_COMPLETED,
  BookNowStatuses.COMPLETION_PENDING,

  BookNowStatuses.COMPLETED
];
